module.exports = __webpack_public_path__ + "img/miner5.3926a446.png";